import styled from '@emotion/styled';
import { DialogContent, TableCell, TableSortLabel } from '@material-ui/core';

export const CustomDialogButtonContainer = styled.div`
  width: 100%;
  display: flex;
  white-space: nowrap;
  flex-direction: row;
  > button {
    margin: 0 8px;
  }
  justify-content: flex-end;
`;

export const CustomDialogContent = styled(DialogContent)`
  min-width: 240px !important;
  font-size: 13px;
`;

export const CustomDialogTableCell = styled(TableCell)(
  ({ header, disableCursor }: { header?: string; disableCursor?: string }) => `
  padding: 0px 4px !important;
  border: none !important;
  ${disableCursor === 'true' ? '' : 'cursor: pointer;'}
  ${header === 'true' ? 'background-color: rgb(230,230,230);' : ''}
  ${header === 'true' ? 'z-index: 100;' : ''}

`,
);

export const CustomDialogTableSortLabelCell = styled(TableSortLabel)`
  svg {
    color: #10a4e4 !important;
  }
`;
